<template>
  <div>
    <el-dialog
      :title="`无码退单(出库订单号:${goodsreturn.outstockOrderId})`"
      :visible.sync="visible"
      width="60%"
      :close-on-press-escape="false">
      <el-form
        ref="ruleForm"
        label-position="top"
        :model="goodsreturn"
        label-width="80px">
        <el-form-item
          label-width="0"
          prop="goodsReturnItems">
          <el-table
            v-loading="loading"
            :data="goodsreturn.goodsReturnItems"
            border>
            <el-table-column
              label="商品名称"
              prop="productName"></el-table-column>
            <el-table-column label="数量">
              <template slot-scope="{$index}">
                <el-input-number
                  v-model="goodsreturn.goodsReturnItems[$index].returnGoodsCount"
                  :precision="0"
                  :min="0"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          :loading="loading"
          @click="toggleModal(false)">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'NotagReturenModal',
  components: {},
  props: {
    originalOrder: {
      type: Object
    },
    fetch: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      goodsreturn: {
        goodsReturnItems: []
      }
    }
  },
  watch: {
    originalOrder: {
      handler(val) {
        this.goodsreturn = {
          ...this.goodsreturn,
          goodsReturnItems: val.productItems,
          ...val
        }
      },
      deep: true
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
      if (!visible) {
        this.goodsreturn = {
          goodsReturnItems: []
        }
      }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('goodsreturn/addgoodsreturnbynotag', {
            payload: {
              vendorId: this.goodsreturn.vendorId,
              outstockOrderId: this.goodsreturn.outstockOrderId,
              goodsReturnItems: this.goodsreturn.goodsReturnItems.map(i => ({ outstockOrderItemId: i.outstockOrderItemId, returnGoodsCount: i.returnGoodsCount }))
            },
            success: () => {
              this.loading = false
              this.fetch && this.fetch()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
